import SortRoundedIcon from '@mui/icons-material/SortRounded';
import LocalAtmRoundedIcon from '@mui/icons-material/LocalAtmRounded';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import AddAlarmRoundedIcon from '@mui/icons-material/AddAlarmRounded';
import MovingRoundedIcon from '@mui/icons-material/MovingRounded';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';

const getClientCurrencyFormatter = (projectCurreny) => {
    return new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: projectCurreny || "CAD",
        maximumFractionDigits: 0,
    })
}

const getPercentageFormatter = () => {
    return new Intl.NumberFormat("en-CA", {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    })
}

export const columnProfiles = [
    {
        id: "",
        type: "text",
        width: 10,
        defaultWidth: 10,
        renderer: () => <span style={{cursor: "pointer"}}> ≡ </span>,
        alwaysVisible: true,
        nonEditable: true,
    },
    {
        id: "name",
        headerIcon: <SortRoundedIcon fontSize="tiny" style={{paddingLeft: 32}} />,
        headerText: "Name",
        type: "customChevron",
        defaultWidth: 300,
        width: 300,
        alwaysVisible: true,
    },
    {
        id: "is_internal",
        headerIcon: <LocalAtmRoundedIcon fontSize="tiny" /> ,
        headerText: "Resource Type",
        type: "customDropdownResourceType",
        visible: true
    },
    {
        id: "vendor_currency",
        headerIcon: <LocalAtmRoundedIcon fontSize="tiny" /> ,
        headerText: "Currency",
        type: "customDropdownCurrency",
        visible: true
    },
    {
        id: "internal_rate",
        headerIcon: <LocalOfferOutlinedIcon fontSize="tiny" /> ,
        headerText: "Internal Rate",
        type: "simpleFormula",
        restricted: true,
    },
    {
        id: "internal_markup",
        headerIcon: <MovingRoundedIcon fontSize="tiny" /> ,
        headerText: "Internal Markup %",
        type: "simpleFormulaPercentage",
        restricted: true,
        formatter: getPercentageFormatter,
    },
    {
        id: "vendor_rate",
        headerIcon: <LocalOfferOutlinedIcon fontSize="tiny" /> ,
        headerText: "Rate",
        type: "dynamicRate",
        visible: true,
    },
    {
        id: "rate_type",
        headerIcon: <AccessTimeRoundedIcon fontSize="tiny" /> ,
        headerText: "Rate Type",
        type: "customDropdownRateType",
        visible: true,
    },
    {
        id: "vendor_client_exchange_rate_saved",
        headerIcon: <LocalAtmRoundedIcon fontSize="tiny" /> ,
        headerText: "FX",
        type: "number",
        visible: false,
        nonEditable: true,
    },
    {
        id: "exchange_rate_buffer",
        headerIcon: <MovingRoundedIcon fontSize="tiny" /> ,
        headerText: "FX Buffer",
        type: "simpleFormula",
        visible: false,
        nonEditable: true,
    },
    {
        id: "quantity",
        headerIcon: <ShoppingCartOutlinedIcon fontSize="tiny" /> ,
        headerText: "Qty",
        type: "simpleFormula",
        visible: true
    },
    {
        id: "days",
        headerIcon: <PeopleOutlineRoundedIcon fontSize="tiny" /> ,
        headerText: "Units",
        type: "simpleFormulaOneAsEmpty",
        visible: true
    },
    {
        id: "ot_1_5",
        headerIcon: <AddAlarmRoundedIcon fontSize="tiny" /> ,
        headerText: "OT 1.5",
        type: "simpleFormula",
        visible: true
    },
    {
        id: "ot_2_0",
        headerIcon: <AddAlarmRoundedIcon fontSize="tiny" /> ,
        headerText: "OT 2.0",
        type: "simpleFormula",
        visible: true
    },
    {
        id: "markup",
        headerIcon: <MovingRoundedIcon fontSize="tiny" /> ,
        headerText: "Markup %",
        type: "simpleFormulaPercentage",
        visible: true,
        formatter: getClientCurrencyFormatter,
    },
    {
        id: "adjustment",
        headerIcon: <MovingRoundedIcon fontSize="tiny" /> ,
        headerText: "Markup $",
        type: "simpleFormula",
        visible: true
    },
    {
        id: "external_notes",
        headerIcon: <NoteAltOutlinedIcon fontSize="tiny" /> ,
        headerText: "External Notes",
        type: "text",
        defaultWidth: 300,
        width: 300,
        visible: true
    },
    {
        id: "internal_notes",
        headerIcon: <NoteAltOutlinedIcon fontSize="tiny" /> ,
        headerText: "Internal Notes",
        type: "text",
        defaultWidth: 300,
        width: 300,
        visible: true,
    },
    {
        id: "internal_budget",
        headerIcon: <PriceCheckIcon fontSize="tiny" /> ,
        headerText: "Internal Cost",
        type: "number",
        nonEditable: true,
        restricted: true,
        formatter: getClientCurrencyFormatter,
    },
    {
        id: "client_budget",
        headerIcon: <PaymentsOutlinedIcon fontSize="tiny" /> ,
        headerText: "Budget",
        type: "number",
        nonEditable: true,
        sticky: true,
        visible: true,
        formatter: getClientCurrencyFormatter,
    },
    {
        id: "client_quoted",
        headerIcon: <PaidOutlinedIcon fontSize="tiny" /> ,
        headerText: "Quoted",
        type: "number",
        nonEditable: true,
        sticky: true,
        alwaysVisible: true,
        formatter: getClientCurrencyFormatter,
    },
]
